export default function Button({ children, type = 'button', disabled, className = '', onClick }) {
  return (
    <button
      type={type}
      className={`btn ${className}`.trim()}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
